import { Box } from "@mui/material"
import { TextBodyMain, TextTitleMain } from "./TextMain"
import ButtonIcon from "#common/buttons/ButtonIcon"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"

export const TitleValue = ({ label, value, icon, hidden, button, noWrap }) => {
	if (!value || hidden) return null

	const Icon = icon
	const IconB = button?.icon || OpenInNewIcon

	return (
		<Box>
			<Box
				display="inline-flex"
				alignItems="center"
				gap={0.5}
				component="span"
				lineHeight={1}
			>
				<TextTitleMain label={label} noWrap={noWrap} />

				{button && (
					<ButtonIcon
						{...button}
						size="small"
						sx={{ p: 0, minWidth: 0, height: "auto", alignSelf: "center" }}
						icon={<IconB color="primary" fontSize="small" />}
					/>
				)}
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				{icon && <Icon fontSize="small" color="action" />}
				<TextBodyMain label={value} noWrap={noWrap} />
			</Box>
		</Box>
	)
}
